import { render, staticRenderFns } from "./McardRequestPage.vue?vue&type=template&id=40535926&scoped=true"
import script from "./McardRequestPage.vue?vue&type=script&lang=js"
export * from "./McardRequestPage.vue?vue&type=script&lang=js"
import style0 from "./McardRequestPage.vue?vue&type=style&index=0&id=40535926&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40535926",
  null
  
)

export default component.exports